/**
 * @typedef {object} Tealium
 * @property {(name: string) => string} codify
 */

/**
 * @typedef {object} AdobeDataLayer
 * @property {(name: string) => any} getState
 */

const parent = /** @type {Window & { tealium?: Tealium; adobeDataLayer?: AdobeDataLayer }} */ (window);

/**
 * @param {string} name
 * @returns {Record<string, any>}
 */
export function getAnalyticVariable(name) {
  return parent.adobeDataLayer?.getState?.(name);
}

/**
 * Converts name to an id
 * @param {string} name
 * @returns {string | undefined}
 */
export function codify(name) {
  return parent.tealium?.codify(name);
}
